export const hintSx = { fontSize: 12, color: "text.secondary" } as const;

// A field's name on the left and its type on the right, the same in the field picker and the replace menu
export const fieldMenuItemSx = { fontSize: 14, display: "flex", justifyContent: "space-between", gap: 3 } as const;
